import { createSideBetOutbound } from '../../api/outbound/pokerOutbounds';
import { isConfigFlagEnabled } from '../../config';
import { getCurrencyAmountString } from '../../utils/currencyUtils';
import { maybePlaySideBetSound } from '../../utils/soundUtils';
import { addSideBetsSummaryHistoryEntry } from './historyActions';
import { addPanelUpdate, clearPanelUpdates } from './panelsActions';
import { addToast } from './toastsActions';
export const CLEAR_SIDE_BETS_STATE = 'CLEAR_SIDE_BETS_STATE';
export const ADD_SIDE_BET = 'ADD_SIDE_BET';
export const DISABLE_MY_SIDE_BET_CONTROLS = 'DISABLE_MY_SIDE_BET_CONTROLS';
export const HIDE_SIDE_BET_ANIMATION = 'HIDE_SIDE_BET_ANIMATION';
export const SET_IS_SELECTING_TARGET = 'SET_IS_SELECTING_TARGET';
export const SET_SIDE_BETS_HAND_RESULT = 'SET_SIDE_BETS_HAND_RESULT';
function clearSideBetsState() {
    return {
        type: CLEAR_SIDE_BETS_STATE
    };
}
export function disableMySideBetControls() {
    return {
        type: DISABLE_MY_SIDE_BET_CONTROLS
    };
}
export function thunkSideBetDoneFromInbound(inbound) {
    return function (dispatch) {
        if (inbound.isSuccess) {
            dispatch(disableMySideBetControls());
        }
        else if (inbound.errorMessage) {
            dispatch(addToast({
                type: 'side-bet-error',
                key: 'side-bet-error',
                message: inbound.errorMessage
            }));
        }
    };
}
function addSideBet(bettorPlayer, targetPlayer, sideBetJacksCost, sideBetJacksPotTotal, targetSeatIndex, isMyPlacedSideBet) {
    return {
        type: ADD_SIDE_BET,
        payload: {
            bettorPlayer,
            targetPlayer,
            sideBetJacksCost,
            sideBetJacksPotTotal,
            targetSeatIndex,
            isMyPlacedSideBet
        }
    };
}
export function thunkAddSideBetFromInbound(inbound) {
    return function (dispatch, getState) {
        const state = getState();
        const { bettorPlayer, targetPlayer, sideBetJacksCost, sideBetJacksPotTotal } = inbound;
        const targetSeatedPlayer = Object.values(state.poker.seatedPlayers).find((currSeatedPlayer) => currSeatedPlayer?.id === targetPlayer.id);
        if (targetSeatedPlayer) {
            const isMyPlacedSideBet = bettorPlayer.id === state.selfData.id;
            dispatch(addSideBet(bettorPlayer, targetPlayer, sideBetJacksCost, sideBetJacksPotTotal, targetSeatedPlayer.seatIndex, isMyPlacedSideBet));
        }
        dispatch(addPanelUpdate('sideBets'));
        if (state.selfData.isSideBettingSettingEnabled) {
            // only play sounds for players with side betting on
            maybePlaySideBetSound(state);
        }
    };
}
export function thunkClearSideBetsState() {
    return function (dispatch) {
        dispatch(clearSideBetsState());
        dispatch(clearPanelUpdates('sideBets'));
    };
}
export function hideSideBetAnimation(seatIndex) {
    return {
        type: HIDE_SIDE_BET_ANIMATION,
        payload: seatIndex
    };
}
export function setIsSelectingSideBetTarget(isSelectingTarget) {
    return {
        type: SET_IS_SELECTING_TARGET,
        payload: isSelectingTarget
    };
}
export function thunkPlaceSideBet(targetPlayerId, socketSend) {
    return function (dispatch) {
        dispatch(setIsSelectingSideBetTarget(false));
        socketSend(createSideBetOutbound(targetPlayerId));
    };
}
function setSideBetsHandResult(sideBetsHandResult) {
    return {
        type: SET_SIDE_BETS_HAND_RESULT,
        payload: sideBetsHandResult
    };
}
function dispatchSideBetsHistorySummary(state, dispatch, inbound) {
    if (!isConfigFlagEnabled('sideBets')) {
        return;
    }
    if (!state.selfData.isSideBettingSettingEnabled) {
        return;
    }
    dispatch(addSideBetsSummaryHistoryEntry(inbound.jacksWonPerWinner, inbound.sideBetWinners, inbound.sideBetLosers));
}
export function thunkShowSideBetHandCompleteFromInbound(inbound) {
    return function (dispatch, getState) {
        const state = getState();
        if (!state.selfData.isSideBettingSettingEnabled) {
            // don't do anything for non-side-bet players
            return;
        }
        dispatch(setSideBetsHandResult({
            type: 'complete',
            handWinners: inbound.handWinners
        }));
        dispatchSideBetsHistorySummary(state, dispatch, inbound);
        const myPlayerId = state.selfData.id;
        if (myPlayerId === undefined) {
            return;
        }
        const isWinner = inbound.sideBetWinners.some(({ id }) => id === myPlayerId);
        const isLoser = inbound.sideBetLosers.some(({ id }) => id === myPlayerId);
        if (!isWinner && !isLoser) {
            // did not side bet, don't show result to this player
            return;
        }
        if (isWinner) {
            dispatch(addToast({
                type: 'side-bet-won',
                key: 'side-bet-result',
                message: `Side Bet Won! (+${getCurrencyAmountString(inbound.jacksWonPerWinner, 'jacks')})`
            }));
        }
        else {
            dispatch(addToast({
                type: 'side-bet-lost',
                key: 'side-bet-result',
                message: 'Side Bet Lost!'
            }));
        }
    };
}
export function thunkShowSideBetHandIncomplete() {
    return function (dispatch, getState) {
        const state = getState();
        if (!state.selfData.isSideBettingSettingEnabled) {
            // don't do anything for non-side-bet players
            return;
        }
        dispatch(setSideBetsHandResult({
            type: 'incomplete'
        }));
    };
}
export function thunkHandleSideBetRefundedFromInbound(inbound) {
    return function (dispatch) {
        dispatch(addToast({
            type: 'side-bet-refunded',
            key: 'side-bet-result',
            message: inbound.message
        }));
    };
}
